export default "__VITE_ASSET__ePkoMFxO__"